import React, { useEffect } from 'react';
import { SkeletonCompiled } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { asyncDateTimeFieldEditViewEntrypoint } from './entrypoint.tsx';
import type { DateTimeFieldEditViewProps } from './index.tsx';

const EMPTY_OBJECT = {} as const;

export const AsyncDateTimeFieldEditView = (props: DateTimeFieldEditViewProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		asyncDateTimeFieldEditViewEntrypoint,
		// use stable reference to avoid re-renders
		EMPTY_OBJECT,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="async-jira-issue-field-date-time-edit-view"
			packageName="jira-issue-field-date-time"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={props}
			fallback={<SkeletonCompiled width="350px" height="40px" />}
			errorFallback="unmount"
		/>
	);
};
